import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { APIResponse } from "../types/Common";
import { STATUS_CODES } from "@src/config/constant";
import InsuranceIdService from "@src/services/InsuranceIdService";


const InsuranceId = createSlice({
    name: 'insuranceId',
    initialState: {
        insuranceDetail: {},
        
    },
    reducers: {
        insuranceDetail: (state, action) => {
            state.insuranceDetail = action.payload
        },
        setInsuranceDetail: (state, action: PayloadAction<Record<string, any>>) => {
            state.insuranceDetail = {...state.insuranceDetail,...action.payload};
        },
        
    }
})


export default InsuranceId.reducer


export const { insuranceDetail,setInsuranceDetail} = InsuranceId.actions


export const getInsuranceDetail = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        InsuranceIdService.getLeadDetail(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        dispatch(setInsuranceDetail(response.data?.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const getAgentPoints = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceIdService.getAgentPoints(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        //dispatch(insuranceDetail(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}



export const getAgentComChangeList = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceIdService.getAgentComChangeList(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        //dispatch(insuranceDetail(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const cancelRequest = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceIdService.cancelRequest(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        //dispatch(insuranceDetail(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const saveAgentDetails = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceIdService.saveAgentDetails(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        //dispatch(insuranceDetail(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const getAgentleadHistory = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceIdService.getAgentleadHistory(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        //dispatch(insuranceDetail(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const agentPointStatus = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceIdService.agentPointStatus(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        //dispatch(insuranceDetail(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}


export const getEstimatedCarPrice = (params: object) => {
    return new Promise((resolve, reject) => {
        InsuranceIdService.getEstimatedCarPrice(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === STATUS_CODES['success']) {
                        resolve(response.data)
                        //dispatch(insuranceDetail(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}
